<nz-spin [nzSpinning]="loading">
  @if (packingListItem) {
    <nz-divider></nz-divider>
    <nz-row [nzGutter]="16" nzJustify="start">
      <nz-col [nzSpan]="24">
        <nz-row [nzGutter]="50">
          <nz-col>
            <div class="ant-statistic">
              <div class="ant-statistic-title">Liste ID:</div>
              <div class="ant-statistic-content">
                <span class="ant-statistic-content-value">
                  {{ packingListItem.id }}
                </span>
              </div>
            </div>
          </nz-col>
          <nz-col>
            <div class="ant-statistic">
              <div class="ant-statistic-title">Liste</div>
              <div class="ant-statistic-content">
                <span class="ant-statistic-content-value">
                  {{ storeLabel }}
                </span>
              </div>
            </div>
          </nz-col>
          <nz-col>
            <div class="ant-statistic">
              <div class="ant-statistic-title">Erstellungsdatum:</div>
              <div class="ant-statistic-content">
                <span class="ant-statistic-content-value">
                  {{ packingListItem.createdAt | datetimeFormat }}
                </span>
              </div>
            </div>
          </nz-col>
          @if (this.packingListItem.isMainDoc) {
            <nz-col>
              <div class="ant-statistic">
                <div class="ant-statistic-title">Gescannte Artikel:</div>
                <div class="ant-statistic-content">
                  <span class="ant-statistic-content-value">
                    <ul class="scanned-articles">
                      @for (scannedArticle of scannedArticles; track scannedArticle) {
                        <li style="display: flex; align-items: center; gap: 8px;">
                          <span>{{scannedArticle.articleNumber}} | {{scannedArticle.articleName}} {{scannedArticle.articleVariantName}} - {{scannedArticle.delivery}}</span>
                          <div class="d-flex align-items-center">
                            <button
                              nz-button
                              nzType="text"
                              nzSize="small"
                              nz-tooltip
                              nzTooltipTitle="Menge bearbeiten"
                              (click)="openEditScannedArticleModal(scannedArticle)"
                              >
                              <span nz-icon nzType="edit" nzTheme="outline"></span>
                            </button>
                            <button
                              nz-button
                              nzType="text"
                              nzSize="small"
                              nzDanger
                              nz-popconfirm
                              nzPopconfirmTitle="Artikel aus der Liste entfernen?"
                              nzOkText="Ja"
                              nzCancelText="Nein"
                              (nzOnConfirm)="deleteScannedArticle(scannedArticle)"
                              nz-tooltip
                              nzTooltipTitle="Artikel entfernen"
                              >
                              <span nz-icon nzType="delete" nzTheme="outline"></span>
                            </button>
                          </div>
                        </li>
                      }
                    </ul>
                  </span>
                </div>
              </div>
            </nz-col>
          }
        </nz-row>
      </nz-col>
    </nz-row>
    <nz-divider></nz-divider>
    @if (currentVisibleArticleIndex !== null && this.packingListItem.isMainDoc || currentVisibleArticleIndex !== null && isOutgoingDocChanging) {
      <nz-row [nzGutter]="16" nzJustify="start">
        <nz-col [nzSpan]="24">
          <nz-row style="margin-bottom: 24px;" [nzGutter]="100">
            <nz-col>
              <div class="ant-statistic">
                <div class="ant-statistic-title">Lagerplatz:</div>
                <div class="ant-statistic-content">
                  <span class="ant-statistic-content-value">
                    {{ currentScannedArticle?.storeLocation }}
                  </span>
                </div>
              </div>
            </nz-col>
            <nz-col>
              <div class="ant-statistic">
                <div class="ant-statistic-title">Artikel-Nr.</div>
                <div class="ant-statistic-content">
                  <span class="ant-statistic-content-value">
                    {{ currentScannedArticle?.articleNumber }}
                  </span>
                </div>
              </div>
            </nz-col>
            <nz-col>
              <div class="ant-statistic">
                <div class="ant-statistic-title">Name:</div>
                <div class="ant-statistic-content">
                  <span class="ant-statistic-content-value">
                    {{ currentScannedArticle?.articleName }}
                  </span>
                </div>
              </div>
            </nz-col>
            <nz-col>
              <div class="ant-statistic">
                <div class="ant-statistic-title">Variante:</div>
                <div class="ant-statistic-content">
                  <span class="ant-statistic-content-value">
                    {{ currentScannedArticle?.articleVariantName }}
                  </span>
                </div>
              </div>
            </nz-col>
          </nz-row>
          <nz-row [nzGutter]="100" style="margin-bottom: 24px;">
            <nz-col>
              <div class="ant-statistic">
                <div class="ant-statistic-title">Bestand Hauptlager:</div>
                <div class="ant-statistic-content">
                  <span class="ant-statistic-content-value">
                    {{ currentScannedArticle?.mainStockInStore }}
                  </span>
                </div>
              </div>
            </nz-col>
            <nz-col>
              <div class="ant-statistic">
                <div class="ant-statistic-title">
                  Bestand {{ storeLabel }}
                </div>
                <div class="ant-statistic-content">
                  <span class="ant-statistic-content-value">
                    {{ currentScannedArticle?.inStock }}
                  </span>
                </div>
              </div>
            </nz-col>
          </nz-row>
          <nz-row nzJustify="center">
            <nz-input-number
              class="article-quantity-picker"
              [(ngModel)]="articleQuantity"
              [nzMin]="0"
              [nzMax]="100000"
            ></nz-input-number>
          </nz-row>
          @if (packingListItem.isMainDoc && currentScannedArticle?.delivery > currentScannedArticle?.mainStockInStore) {
            <nz-row
              nzJustify="center"
              style="margin-top: 24px;"
              >
              <nz-alert
                nzShowIcon
                nzType="error"
                nzMessage="Fehler"
                nzDescription="Artikelmenge ist kleiner als Menge in Hechendorf, bitte korrigieren und neue Menge speichern."
              ></nz-alert>
            </nz-row>
          }
          @if (packingListItem.isMainDoc && currentScannedArticle?.delivery === null) {
            <nz-row
              nzJustify="center"
              style="margin-top: 24px;"
              >
              <nz-alert
                nzShowIcon
                nzType="error"
                nzMessage="Fehler"
                nzDescription="Artikelmenge ist nicht eingestellt, bitte korrigieren Sie den Wert und speichern Sie."
              ></nz-alert>
            </nz-row>
          }
        </nz-col>
      </nz-row>
      <nz-divider></nz-divider>
      <nz-row nzJustify="space-between">
        <nz-col>
          @if (scannedArticles.length > 1 && currentVisibleArticleIndex > 0 && !isOutgoingDocChanging) {
            <button
              nz-button
              nzType="default"
              (click)="backToPrevious()"
              >
              Zurück
            </button>
          }
        </nz-col>
        <nz-col>
          <nz-row>
            @if (packingListItem.isMainDoc) {
              <button
                nz-button
                nzType="primary"
                nz-popconfirm
                nzPopconfirmTitle="Sind Sie sicher?"
                nzOkText="Ja"
                nzCancelText="Nein"
                (nzOnConfirm)="deleteArticle()"
                style="margin-right: 24px;"
              >Artikel löschen</button>
            }
            @if (isOutgoingDocChanging) {
              <button
                nz-button
                nzType="primary"
                style="margin-right: 24px;"
                (click)="isOutgoingDocChanging = false"
              >Abbrechen</button>
            }
            <button
              nz-button
              nzType="primary"
              style="margin-right: 24px;"
              [disabled]="
              (articleQuantity !== null && articleQuantity === currentScannedArticle?.delivery)"
              (click)="saveArticleQuantity()"
            >Neue Liefermenge speichern</button>
            @if (!isOutgoingDocChanging) {
              <button
                nz-button
                nzType="primary"
                (click)="generateDeliveryNote()"
              >Lieferschein generieren</button>
            }
          </nz-row>
        </nz-col>
      </nz-row>
      <nz-divider></nz-divider>
    }
    @if (this.packingListItem.isOutgoingDoc) {
      <nz-row [nzGutter]="16" nzJustify="start">
        <nz-col [nzSpan]="24" class="table-wrapper">
          <nz-table [nzFrontPagination]="false" [nzData]="scannedArticles">
            <thead>
              <tr>
                <th>Lagerplatz</th>
                <th>Artikel-Nr</th>
                <th>Name</th>
                <th>Variante</th>
                <th>EAN</th>
                <th>Liefermenge</th>
              </tr>
            </thead>
            <tbody>
              @for (data of scannedArticles; track data) {
                <tr>
                  <td>{{data.storeLocation}}</td>
                  <td>{{data.articleNumber}}</td>
                  <td>{{data.articleName}}</td>
                  <td>{{data.articleVariantName}}</td>
                  <td>{{data.ean}}</td>
                  <td>{{data.delivery}}</td>
                </tr>
              }
            </tbody>
          </nz-table>
        </nz-col>
      </nz-row>
      <nz-divider></nz-divider>
      <nz-row nzJustify="end">
        <nz-col >
          <nz-row >
            <button
              nz-button
              nzType="primary"
              nz-popconfirm
              nzPopconfirmTitle="Sind Sie sicher?"
              nzOkText="Ja"
              nzCancelText="Nein"
              (nzOnConfirm)="generateDeliveryNote()"
            >Lieferung bestätigen</button>
          </nz-row>
        </nz-col>
      </nz-row>
      <nz-divider></nz-divider>
    }
    <div class="ean-scanner--container">
      <span>Die Produkt scannen: </span>
      <textarea
        [(ngModel)]="currentEan"
        (ngModelChange)="eanScan($event)"
        [ngModelOptions]="{ standalone: true }"
        #eanField
        nz-input
        rows="1"
      ></textarea>
    </div>
  }
</nz-spin>


<app-delivery-note-error-modal #deliveryNoteErrorModalComponent />

<nz-modal
  [nzMaskClosable]="false"
  [(nzVisible)]="isEditQuantityModalVisible"
  nzTitle="Menge bearbeiten"
  [nzContent]="editQuantityModalContent"
  [nzFooter]="editQuantityModalFooter"
  [nzClosable]="false"
  >
  <ng-template #editQuantityModalContent>
    <div style="display: flex; flex-direction: column; align-items: center; gap: 16px;">
      @if (editingArticle) {
        <div>
          <b>{{ editingArticle.articleNumber }}</b> | {{ editingArticle.articleName }} {{ editingArticle.articleVariantName }}
        </div>
      }
      <nz-input-number
        [(ngModel)]="editingQuantity"
        [nzMin]="0"
        [nzMax]="100000"
        style="width: 120px;"
      ></nz-input-number>
    </div>
  </ng-template>

  <ng-template #editQuantityModalFooter>
    <button
      nz-button
      nzType="default"
      (click)="closeEditQuantityModal()"
    >Abbrechen</button>
    <button
      nz-button
      nzType="primary"
      [disabled]="editingArticle && editingQuantity === editingArticle.delivery"
      (click)="saveEditedScannedArticleQuantity()"
    >Speichern</button>
  </ng-template>
</nz-modal>

